import React from 'react'

import classNames from 'classnames'
import { useSelector } from 'react-redux'

import { useAuth } from 'routes/Menu/domains/auth'
import { getIsBuildYourBoxCtaEnabled } from 'selectors/features'

import { Benefits, BenefitType } from '../../Benefits'
import { Cta, CtaTexts, useGetCtaProps } from '../../Cta'
import { DISCOUNT_OPTIMISATION_PROMO_CODE_DATA } from '../../homeConfig'
import { getPromoBannerState } from '../../homeUtils'
import { GetStartedProps } from './GetStartedModels'

import css from './GetStartedStyles.css'

export const GetStarted = ({ isHeroCTA, isSticky, maxHeight, ctaRef }: GetStartedProps) => {
  const isBuildYourBoxCtaEnabled = useSelector(getIsBuildYourBoxCtaEnabled)
  const { promoCode } = useSelector(getPromoBannerState)
  const { isAuthenticated } = useAuth()
  const { ctaText, ctaUri } = useGetCtaProps()

  const isDiscountOptimised = promoCode === DISCOUNT_OPTIMISATION_PROMO_CODE_DATA.defaultPromoCode

  const ctaTextWithDiscount = isBuildYourBoxCtaEnabled
    ? CtaTexts.BUILD_BOX_WITH_DISCOUNT
    : CtaTexts.GET_STARTED_WITH_DISCOUNT

  const ctaTextWithoutDiscount =
    isBuildYourBoxCtaEnabled && !isAuthenticated ? CtaTexts.BUILD_BOX : ctaText

  const ctaTextDynamic =
    isSticky && !isHeroCTA && !isAuthenticated && !isDiscountOptimised
      ? ctaTextWithDiscount
      : ctaTextWithoutDiscount

  const className = isHeroCTA
    ? ''
    : classNames(css.mobileStickyInitial, css.mobileStickyRemoval, {
        [css.mobileSticky]: isSticky,
        [css.hideShadow]: maxHeight && isSticky,
      })

  return (
    <div
      className={className}
      ref={ctaRef}
      style={maxHeight && !isHeroCTA ? { top: `${maxHeight}px` } : {}}
    >
      <Cta
        ctaUri={ctaUri}
        trackingSectionName={isHeroCTA ? 'hero' : 'stickyCTA'}
        dataTesting={isHeroCTA ? 'homepageHeroCTA' : 'stickyCTA'}
      >
        {ctaTextDynamic}
      </Cta>
      <Benefits pickFilter={[BenefitType.NO_LOCK_IN]} />
    </div>
  )
}
